import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EntityType } from 'src/app/enums/enums';
import { IPaginatorEvent } from 'src/app/modules/common/table/table.component';
import { DateTransformService } from 'src/app/services/date-transform.service';
import { DocumentService } from 'src/app/services/document.service';
import { DocumentFormComponent } from '../document-form/document-form.component';

@Component({
  selector: 'app-company-documents-list',
  templateUrl: './company-documents-list.component.html',
  styleUrls: ['./company-documents-list.component.scss'],
})
export class CompanyDocumentsListComponent {
  columns = ['Nombre', 'Empresa', 'Tipo', 'Vencimiento', 'Creado por', 'Modificado por'];
  columnsNames = ['name', 'clientName', 'documentType', 'expiration', 'createdBy', 'updatedBy'];

  docsList: any[];
  searchText: string;
  showLoading: boolean = false;
  usersList: any = [];
  total: number = 0;
  offset: number = 0;
  limit: number = 25;

  constructor(
    private documentService: DocumentService,
    public dialog: MatDialog,
    private dateTransformService: DateTransformService,
  ) { }

  ngOnInit() {
    this.getCompanyDocs();
  }

  search(query: string) {
    this.offset = 0;
    this.searchText = query;
    this.showLoading = true;
    this.getCompanyDocs();
  }

  handlePageChange(event: IPaginatorEvent) {
    this.offset = event.offset;
    this.limit = event.limit;
    this.getCompanyDocs();
  }

  getCompanyDocs() {
    const params = {
      offset: this.offset,
      limit: this.limit,
      entityType: EntityType.COMPANY,
      ...(this.searchText && { search: this.searchText }),
    };
    this.documentService.findAll(3, params).subscribe((res:any) => {
      this.showLoading = false;
      this.docsList = this.dateTransformService.transformDates(res.data);
      this.total = res.total;
    });
  }

  openModal() {
    this.dialog.open(DocumentFormComponent, {
      width: '30%',
      minWidth: '300px',
      data: { isClient: false, isVehicle: false },
      autoFocus: false,
    }).afterClosed().subscribe(() => {
      this.getCompanyDocs();
    });
  }

  update(event:number) {
    this.documentService.findOne(event)
      .subscribe((res) => {
        this.dialog.open(DocumentFormComponent, {
          width: '30%',
          minWidth: '300px',
          data: { isClient: false, isVehicle: false, document: res },
          autoFocus: false,
        }).afterClosed().subscribe(() => {
          this.getCompanyDocs();
        });
      });
  }

  delete(event:any) {
    this.documentService.delete(event)
      .subscribe(() => {
        this.getCompanyDocs();
      });
  }
}
